import { CommentType } from 'types/comments';

export const getCommentActorLabel = (comment: CommentType): string => {
  const actor = comment?.created_by;

  if (!actor) {
    return '';
  }

  if (typeof actor === 'string') {
    return actor;
  }

  const isStaff = Boolean(actor.is_staff || actor.is_superuser);

  if (isStaff) {
    return 'Further Support';
  }

  return actor.name ?? actor.full_name ?? actor.username ?? actor.email ?? '';
};
